import { LocationStrategy } from '@angular/common';
import { Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { PaymentAuthService } from 'app/modules/payment/_services/payment-auth.service';
import { MiscService } from 'app/shared/misc.service';

@Component({
  selector: 'app-payment-view',
  templateUrl: './payment-view.component.html',
  styleUrls: ['./payment-view.component.scss']
})
export class PaymentViewComponent implements OnInit {
  @Input() paymentDetails: any = null;

  productForm: FormGroup;

  screenWidth: number = window.innerWidth; // Initialize with the current width
  isMobile: boolean = this.screenWidth <= 768; // Example breakpoint
  merchantName: string = '';
  merchantId: string = '';
  currency: string = '';
  

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.screenWidth = (event.target as Window).innerWidth;
    this.isMobile = this.screenWidth <= 768; // Adjust based on your breakpoint
  }

  get productFields(): FormArray {
    return this.productForm.get("productFields") as FormArray;
  }
  
  constructor(
    private location: LocationStrategy,
    public miscService: MiscService,
    private fb: FormBuilder,
    private paymentAuthService: PaymentAuthService,
  ) { 
    this.productForm = this.fb.group({
      productFields: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth; // Ensure it's set on initialization
    this.isMobile = this.screenWidth <= 768;
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    this.getMerchant(changes.paymentDetails.currentValue.merchant_id);
    this.initializeForm(changes.paymentDetails.currentValue.products);
  }

  back = () => {
    this.location.back();
  }

  print = () => {
    window.print();
  }


  openDescription(id: number){
    this.productFields.controls.forEach((control, index) => {
      if(index === id){
        control.get('isDescOpen')?.setValue(
          !control.get('isDescOpen')?.value
        );
      }
    })
  }

  // listValidProductNames(products: string[]): string {
  //   const productFields = products; // Get form array controls
  //   return productFields.join(", ");
  // }

  initializeForm(products: any[]): void {
    products.forEach((product) => {
      const formattedAmount = parseFloat(product.amount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      const group = this.fb.group({
      productName: [product.name], // Readonly, not used in the form directly
      description: [{ value: product.description, disabled: true }],
      amount: [{ value: formattedAmount, disabled: true }],
      product_id: [product.product_id],
      isDescOpen: [false]
      });

      this.productFields.push(group);
    });
  }

  getMerchant(id: string){
    this.paymentAuthService.fetchMerchantDetails(id).subscribe((res: any) => {
      if(res){
        this.merchantName = res.merchant.branch_name;
        this.currency = res.merchant.currency.currency_sign;
      }
    }
    )
  }

}
